import { render } from "./VerticalBarChart.vue?vue&type=template&id=4b090dd2"
import script from "./VerticalBarChart.vue?vue&type=script&lang=js"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__